import { makeTable } from "../utils/tables";
import random from "lodash/random";

export const startingBonuses = makeTable("startingBonuses", [
  {
    name: "A random cosmic mutation",
    variants: [
      {
        name: "GENERATOR.",
        description:
          "Part of the brain converts to a computer that can be activated to create programs, transferred via skin contact. They have the player character's DNA encoded in them.",
      },
      {
        name: "TELEKINESIS.",
        description:
          "Can lift, move, pull and generally alter the direction and speed of an object, using the mind. Up to the size of a hand-held object. Lasts one minute.",
      },
      {
        name: "TELEPATHY.",
        description:
          "Can put a single word or feeling in another person’s mind.",
      },
      { name: "VACUUM GILLS.", description: "No need to breathe." },
      {
        name: "VOID CLOUD.",
        description:
          "Can create a human-sized spherical cloud around a person or object. All sound and light is stopped within the cloud.",
      },
      {
        name: "CRYSTAL MEMBRANE.",
        description:
          "Light bends around the player character, who becomes invisible while standing still without clothes. Only those actively searching will notice the player character when they move.",
      },
      {
        name: "TECH TALKER.",
        description:
          "Can communicate with electronics and give one simple order, for example “open”, “turn off” or “change direction”.",
      },
      {
        name: "MAGNETIC.",
        description:
          "Magnetic blisters form on hands and feet. The magnetic force is strong enough for climbing on walls and ceilings.",
      },
      {
        name: "AUGMENTED PERCEPTION",
        description:
          "Vision becomes sensitive to the full electromagnetic spectrum, including infrared heat emission and x-ray frequencies. Also allows for seeing through solid materials. Effect lasts a short moment.",
      },
      {
        name: "SYMBIOTIC.",
        description:
          "Can take over a small animal in sight, by sending whispered commands through the void. Allows you to control its movements, sense what it senses and feel what it feels.",
      },
      {
        name: "LINKED.",
        description:
          "Can touch an object and create a connection to it. Can feel the rough direction and distance to the object for one week.",
      },
      {
        name: "APAC BRIDGE.",
        description:
          "Creates a portal between current location and the location of a recent memory, up to a week back. Lasts long enough for 1d4 persons to pass through.",
      },
      {
        name: "THERMAL CONDUIT.",
        description:
          "Can make the body withstand extreme temperatures, or create a small region of extreme temperature in the palm of the hand.",
      },
      {
        name: "TRANSCEIVER.",
        description:
          "Can transmit and receive radio messages, and eavesdrop on others. The range depends on the amount of interfering material, from 50 meters inside a station up to kilometers in open space. Lasts until concentration is dropped.",
      },
      {
        name: "TWO HEARTS.",
        description: "Can run, climb, jump and lift twice as much as usual.",
      },
      {
        name: "BOOSTED METABOLISM.",
        description:
          "Can eat anything from blood to batteries, and convert it to nutrition and energy. One kilogram of matter heals 1d4 hit points.",
      },
      {
        name: "VIBRATION DAMPER SKIN.",
        description:
          "The skin starts to shimmer. During the effect, slow moving, sharp objects, like knives, fists and spears, are stopped completely. Fast projectiles can penetrate the protection. Lasts one minute.",
      },
      {
        name: "COSMIC SOMATOSENSORY SYSTEM.",
        description:
          "Can touch something and get a word, picture or feeling of what has happened to the object recently.",
      },
      {
        name: "FEEDBACK LOOP.",
        description:
          "Can jump back ten seconds in time, at the cost of losing one important memory, chosen by the player.",
      },
      {
        name: "BLACK HOLE MONSTER.",
        description:
          "Can create a portal and from it lure a creature. Roll a random creature (p. 94) and roll for reaction (p. 37) with a –2 modifier.",
      },
    ],
  },
  {
    name: "+3 starting HP (included).",
    hpModifier: 3,
  },
  { name: "A heavy EVA suit." },
  { name: "A pistol." },
  {
    name: "An AI guard animal (DR 13, {hp} HP, bite 1d6).",
    getValues: () => ({ hp: random(1, 4) }),
  },
  {
    name: "An old crew member (0 in all abilities, DR 12, {hp} HP). You have always been close.",
    getValues: () => ({ hp: random(1, 6) }),
  },
]);
